import { useSelector } from 'react-redux';
import { TBusinessType } from '../../entities/general.entities';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import { Dropdown } from '../shared';

interface Props {
  value?: TBusinessType;
  onChange: (value: TBusinessType | undefined) => void;
  className?: string;
  showAll?: boolean;
  disabled?: boolean;
}

const SelectCropType = ({
  value,
  onChange,
  className,
  showAll = false,
  disabled,
}: Props) => {
  const lang = useSelector(selectLang);

  const options = [
    ...(showAll
      ? [{ id: 'ALL', value: '', label: translate(lang, 'All') }]
      : []),
    { id: 'MUSSEL', value: 'MUSSEL', label: translate(lang, 'Mussel') },
    { id: 'OYSTER', value: 'OYSTER', label: translate(lang, 'Oyster') },
    { id: 'SEAWEED', value: 'SEAWEED', label: translate(lang, 'Seaweed') },
  ];

  return (
    <Dropdown
      className={className}
      label={translate(lang, 'Crop type')}
      options={options}
      onChange={(v: string) =>
        v.length <= 0 ? onChange(undefined) : onChange(v as TBusinessType)
      }
      value={value ?? ''}
      disabled={disabled}
    />
  );
};

export default SelectCropType;
